"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseContentQuery_1 = require("./BaseContentQuery");
var CommentaryQuery = /** @class */ (function (_super) {
    __extends(CommentaryQuery, _super);
    function CommentaryQuery() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CommentaryQuery.prototype.initialize = function (executionOptions) {
        this.fillKeyFromQuery('key', 'keyQuery', executionOptions);
    };
    CommentaryQuery.prototype.getOptions = function () {
        var _a = this.queryOptions, entityType = _a.entityType, entityConditional = _a.entityConditional, key = _a.key, keyQuery = _a.keyQuery, entityKey = _a.entityKey, entityIndex = _a.entityIndex, _b = _a.options, options = _b === void 0 ? {} : _b;
        return __assign({ entityType: entityType,
            entityConditional: entityConditional,
            key: key,
            keyQuery: keyQuery,
            entityKey: entityKey,
            entityIndex: entityIndex }, (options.commentaries || {}));
    };
    CommentaryQuery.prototype.getRawValue = function (executionOptions) {
        return this.getRawValueForContentElement(executionOptions, 'commentary');
    };
    return CommentaryQuery;
}(BaseContentQuery_1.BaseContentQuery));
exports.CommentaryQuery = CommentaryQuery;
//# sourceMappingURL=CommentaryQuery.js.map